import { Routes } from '@angular/router';
import { FeatureFlagTypes } from '@raptor-fe/core';
import {
    applicationContextReadyGuard,
    AuthenticatedGuard,
    featureFlagGuard,
    NamedRoutes,
    RouteSegments,
    unauthenticatedGuard,
} from '@raptor-fe/services';
import { CodeLoginComponent, LaunchComponent } from '@raptor-fe/ui';
import { LoginComponent } from './ui/login/login.component';
import { WelcomeScreenComponent } from './ui/welcome-screen/welcome-screen.component';
import { landingGuard } from './landing.guard';

export const routes: Routes = [
    {
        path: '',
        redirectTo: NamedRoutes.login().path,
        pathMatch: 'full',
    },
    {
        path: RouteSegments.LOGIN,
        canActivate: [unauthenticatedGuard],
        component: LoginComponent,
    },
    {
        path: RouteSegments.CODE_LOGIN,
        canActivate: [],
        component: CodeLoginComponent,
    },
    {
        path: RouteSegments.LAUNCH,
        canActivate: [],
        component: LaunchComponent,
    },
    {
        path: RouteSegments.SELF_CHECK_IN,
        loadChildren: () => import('@raptor-fe/self-check-in').then((m) => m.publicRoutes),
    },
    {
        path: RouteSegments.LANDING,
        canActivate: [AuthenticatedGuard, landingGuard],
        children: [],
    },
    {
        path: RouteSegments.APP,
        canActivate: [AuthenticatedGuard, applicationContextReadyGuard],
        children: [
            {
                path: RouteSegments.WELCOME,
                component: WelcomeScreenComponent,
            },
            {
                path: RouteSegments.DASHBOARD,
                canActivate: [featureFlagGuard(FeatureFlagTypes.DigitalVehicleInspection, () => NamedRoutes.home().path)],
                loadChildren: () => import('@raptor-fe/dashboard-web').then((m) => m.routes),
            },
            {
                path: RouteSegments.HOME,
                loadComponent: () => import('./ui/home/home-page.component').then((m) => m.HomePageComponent),
            },
            {
                path: RouteSegments.DVI,
                loadChildren: () => import('@raptor-fe/dvi-web').then((m) => m.routes),
            },
            {
                path: RouteSegments.APPOINTMENTS,
                loadChildren: () => import('@raptor-fe/appointments-web').then((m) => m.routes),
            },
            {
                path: RouteSegments.DVI_CONSOLIDATED_REPORT,
                loadChildren: () => import('@raptor-fe/dvi-report').then((m) => m.routes),
            },
            {
                path: RouteSegments.SETTINGS,
                loadChildren: () => import('./features/tenant-management/marlin-tenant.routes').then((m) => m.marlinTenantRoutes),
            },
            {
                path: RouteSegments.SETTINGS,
                loadChildren: () => import('@raptor-fe/user-management').then((m) => m.routes),
            },
            {
                path: RouteSegments.SETTINGS,
                loadChildren: () => import('@raptor-fe/role-management').then((m) => m.routes),
            },
            {
                path: RouteSegments.SETTINGS,
                loadChildren: () => import('@raptor-fe/agreement-management').then((m) => m.routes),
            },
            {
                path: RouteSegments.SETTINGS,
                loadChildren: () => import('@raptor-fe/appointment-management').then((m) => m.routes),
            },
            {
                path: RouteSegments.SETTINGS,
                loadChildren: () => import('@raptor-fe/theme-management').then((m) => m.routes),
            },
            {
                path: RouteSegments.SETTINGS,
                loadChildren: () => import('@raptor-fe/branch-management').then((m) => m.routes),
            },
            {
                path: RouteSegments.SETTINGS,
                loadChildren: () => import('@raptor-fe/device-allowlist-management').then((m) => m.routes),
            },
            {
                path: RouteSegments.SETTINGS,
                loadChildren: () => import('@raptor-fe/system-announcement-management').then((m) => m.routes),
            },
            {
                path: RouteSegments.SETTINGS,
                loadChildren: () => import('@raptor-fe/self-check-in').then((m) => m.settingsRoutes),
            },
            {
                path: RouteSegments.SETTINGS,
                loadChildren: () => import('@raptor-fe/settings-management').then((m) => m.routes),
            },
            {
                path: RouteSegments.SETTINGS,
                loadChildren: () => import('@raptor-fe/translation-management').then((m) => m.routes),
            },
            {
                path: RouteSegments.JOB_CATEGORY,
                loadChildren: () => import('@raptor-fe/job-category-management').then((m) => m.routes),
            },
            {
                path: RouteSegments.CUSTOMER,
                loadChildren: () => import('@raptor-fe/customer-management').then((m) => m.routes),
            },
            {
                path: RouteSegments.PICKUP_OPTION,
                loadChildren: () => import('@raptor-fe/pickup-option-management').then((m) => m.routes),
            },
            {
                path: RouteSegments.USER_DEVICE,
                loadChildren: () => import('@raptor-fe/user-device-management').then((m) => m.routes),
            },
            {
                path: RouteSegments.TIME_CLOCK,
                loadChildren: () => import('@raptor-fe/time-clock-web').then((m) => m.routes),
            },
            {
                path: RouteSegments.WORK_ORDER,
                loadChildren: () => import('@raptor-fe/work-order-management').then((m) => m.routes),
            },
            {
                path: RouteSegments.AUDIT_LOG,
                loadChildren: () => import('@raptor-fe/audit-log-management').then((m) => m.routes),
            },
        ],
    },
    {
        path: '**',
        redirectTo: NamedRoutes.landing().path,
        pathMatch: 'full',
    },
];
